import {Alert, AlertTitle, Box} from "@mui/material";
import {useState} from "react";
import {useLocation} from "react-router-dom";
import {useConfig} from "../../providers/ConfigProvider";

enum Severity {
  error = "error",
  warning = "warning",
  info = "info",
  success = "success"
}

interface MessageBannerProps {
  className?: string;
  override?: {
    dismissable?: boolean;
  }
}

function isSeverity(severity: string | undefined): severity is Severity {
  return !!severity && Object.values(Severity).includes(severity as Severity);
}

export const MessageBanner = ({className, override}: MessageBannerProps) => {
  const config = useConfig();
  const location = useLocation();
  const title = config?.banner?.title;
  const description = config?.banner?.description;
  const dismissable = override?.dismissable ?? config?.banner?.dismissable;
  const severity = config?.banner?.severity;
  const renderOnlyInTheseRoutes = config?.banner?.renderOnlyInTheseRoutes;

  if (!isSeverity(severity) || (!title && !description)) {
    return null;
  }

  // If renderOnlyInTheseRoutes is defined and not empty, check if current route matches
  if (renderOnlyInTheseRoutes && renderOnlyInTheseRoutes.length > 0) {
    const currentPath = location.pathname;
    const shouldRender = renderOnlyInTheseRoutes.some(route => {
      // Exact match
      if (currentPath === route) return true;
      // Check if current path starts with the route (for nested routes)
      return currentPath.startsWith(route + '/');
    });

    if (!shouldRender) {
      return null;
    }
  }

  const [show, setShow] = useState(true);

  if (!show) {
    return null
  }

  return <Alert
    severity={severity}
    className={className}
    onClose={dismissable ? () => setShow(false) : undefined}
    title={title}
    sx={{ alignItems: 'center' }}
  >
    {title && <AlertTitle>{title}</AlertTitle>}
    <Box sx={{ whiteSpace: 'pre-line' }}>{description}</Box>
  </Alert>
}